
export interface CaseManagerFilter {
    text: string;
    value: string;
}

export interface CaseStatusFilter {
    text: string;
    value: string;
}

export interface CaseTypeFilter {
    text: string;
    value: string;
}

export interface CaseFilterModel {
    caseManagerFilter: CaseManagerFilter[];
    caseStatusFilter: CaseStatusFilter[];
    caseTypeFilter: CaseTypeFilter[];
}
export class CaseSelectedFilterModel {
    caseManager: string[] = [];
    // orgId: string|undefined|null=  APP_Config().REACT_APP_ORG_ID;
    orgId?: string | null = null;;
    sortColumn: string | null = null;
    sortDirection: string | null = null;
    caseType: string[] = [];
    lor?: string[] = [];
    caseStatus: string[] = [];
    searchKey: string | null = null;
}


